import { hexToRGBA } from './hex-to-rgba.js';
export const makeBoxShadow = (boxShadow, { shadows, colors }) => {
    if (boxShadow.style === 'none')
        return shadows.styles.none;
    return `${shadows.styles[boxShadow.style]} ${hexToRGBA(colors.shadows[boxShadow.color], shadows.alphas[boxShadow.alpha])}`;
};
//# sourceMappingURL=make-box-shadow.js.map